import type { ViewFilterModifier } from "@regrello/graphql-api";

/** A type that describes the ways in which a __boolean__ value can be filtered. */
export type RegrelloFilterDefinition_BooleanValue = {
  type: "boolean";
  filter: {
    operator: "EQUALS";
    value: boolean;
    modifier?: ViewFilterModifier;
  };
};

export const regrelloFilterOperators_BooleanValue: Record<
  RegrelloFilterDefinition_BooleanValue["filter"]["operator"],
  true
> = {
  EQUALS: true,
};

export function getRegrelloDefaultFilterDefinitionBooleanValue(): RegrelloFilterDefinition_BooleanValue {
  return {
    type: "boolean",
    filter: {
      operator: "EQUALS",
      value: true,
    },
  };
}

export function getRegrelloFilterDefinitionBooleanValue(value: boolean): RegrelloFilterDefinition_BooleanValue {
  return {
    type: "boolean",
    filter: {
      operator: "EQUALS",
      value,
    },
  };
}
